/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TxStatuses/view.blocks to change it.
import React from 'react'
import SetupAction from './SetupAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TxStatuses({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/TxStatuses"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Tx statuses"
/>
<div
  data-testid="TxStatuses.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TxStatuses.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="(Tx statuses are applied at Parent Company level)"
 fontStyle="italic"
/>
</div>
<div
  data-testid="TxStatuses.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}